/**
 * Call with details.
 */
export default class Call {
  /**
   * Unique ID.
   */
  public uq_id: string;

  /**
   * Call ID.
   */
  public id: string;

  /**
   * Revision ID.
   */
  public revision_id: string = '';

  /**
   * Room ID.
   */
  public room_id: string = '';

  /**
   * Table number.
   */
  public table_numbers: string = 'all';

  /**
   * Room options.
   */
  public options: Array<{ name: string, amount: string }> | null = null;

  /**
   * Date from, as ISO string.
   */
  public date_from: string | null = null;

  /**
   * Date to, as ISO string.
   */
  public date_to: string | null = null;

  /**
   * Call type.
   */
  public type: string | null = null;

  /**
   * Contacts.
   */
  public contacts: Array<{ name: string, phone: string }> = [];

  /**
   * Persons.
   */
  public persons: number | null = null;

  /**
   * Price per person.
   */
  public price_per_person: number | null = null;

  /**
   * Manager`s comments.
   */
  public manager_comments: string | null = null;

  /**
   * Room created date.
   */
  public created_at: any = 'null';
}
